import styled from "@emotion/styled"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { SkeletonComponent } from "./SkeletonComponent"
import { SkeletonText } from "./SkeletonText"

export const SkeletonRadioButton = () => (
	<Wrapper>
		<Circle />
		<SkeletonText $width="200px" />
	</Wrapper>
)

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: ${spacingStaticSm};
`

const Circle = styled(SkeletonComponent)`
	height: 28px;
	width: 28px;
	border-radius: 50%;
`
